import React from "react";
import styled from "styled-components";
import NavbarItemActive from "./NavbarItemActive";
import NavbarItemInactive from "./NavbarItemInactive";

const NavbarItem = ({ labelText, isActive, handleClick ,showBizTripTutorial}) => {
  return (
    <NavbarItemWrapper onClick={handleClick}>
      {isActive ? (
        <NavbarItemActive labelText={labelText} showBizTripTutorial={showBizTripTutorial}/>
      ) : (
        <NavbarItemInactive labelText={labelText} showBizTripTutorial={showBizTripTutorial}/>
      )}
    </NavbarItemWrapper>
  );
};

export default NavbarItem;

const NavbarItemWrapper = styled.div`
  cursor: pointer;
`;
